import { createRouter, createWebHistory } from 'vue-router';

import Category from '@/views/CategoryPage.vue';
import Contact from '@/views/ContactPage.vue';
import DefaultPage from '@/views/DefaultPage.vue';
import Enter from '@/views/EnterPage.vue';
import Home from '@/views/HomePage.vue';
import Portfolio from '@/views/PortfolioPage.vue';

const routes = [
    {
        path: '/',
        name: 'LandingPage',
        component: Enter,
    },
    {
        path: '/:lang/',
        name: 'HomePage',
        component: Home,
    },
    {
        path: '/:lang/contact',
        name: 'ContactPage',
        component: Contact,
    },
    {
        path: '/:lang/portfolio',
        name: 'PortfolioPage',
        component: Portfolio,
    },
    {
        path: '/:lang/portfolio/:alias',
        name: 'CategoryPage',
        component: Category,
        meta: { showModal: false },
        children: [
            {
                path: ':id',
                name: 'ProductPage',
                meta: { showModal: true },
            },
        ],
    },
    {
        path: '/:lang/:alias',
        name: 'DefaultPage',
        component: DefaultPage,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (
            (to.name === 'CategoryPage' && from.name === 'ProductPage') ||
            (from.name === 'CategoryPage' && to.name === 'ProductPage')
        ) {
            return false;
        }

        return savedPosition || { top: 0 };
    },
    routes,
});

export default router;
